import crud from "./_crud";
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('incident', 'la incidencia', 'las incidencias');

// const postFolios = (options)=>{
//     return async (dispatch, getState)=>{
//         const state = getState()
//         const res = await callApi('/incident/add_incident_folio', {
//             method: 'POST',
//             headers: {
//                 Authorization: state.app?.user?.token,
//             },
//             params: options?.params
//         })
//         console.log('res.body', res.body)
//         // dispatch({
//         //     type: `POST_FOLIOS`,
//         //     response: res.body,
//         // })

//         return res.body
//     }
// }

const importIncidents = (options) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(`/incident/import_incidents`, {
            method: 'POST',
            headers: {
                Authorization: state.app.user.token,
            },
            body: JSON.stringify({
                options,
            }),
            successMessage: `Se agreron las incidencias correctamente.`,
        })
        showSuccessMessage('Se registraron las incidencias correctamente.')
        return res.body
    }
}

export default { ...actions, importIncidents }
